import { render, staticRenderFns } from "./GenerateRoyaltyReportTerritory.vue?vue&type=template&id=1796b1fb&scoped=true"
import script from "./GenerateRoyaltyReportTerritory.vue?vue&type=script&lang=js"
export * from "./GenerateRoyaltyReportTerritory.vue?vue&type=script&lang=js"
import style0 from "./GenerateRoyaltyReportTerritory.vue?vue&type=style&index=0&id=1796b1fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1796b1fb",
  null
  
)

export default component.exports